// extracted by mini-css-extract-plugin
export default {"carrossel":"ListagemItens_carrossel__Q5VqJ"};